<template>
  <div class="list" name="info">
    <el-card class="authSearchCard" shadow="never">
      <el-tabs v-model="search_sale.isChainLogic" @tab-click="handleTab">
        <el-tab-pane label="轻松版授权" name="0"></el-tab-pane>
        <el-tab-pane label="连锁版授权" name="1"></el-tab-pane>
      </el-tabs>
      <el-form :inline="true" class="demo-inline-form" :model="search_sale">
        <el-form-item label="商户编号">
          <el-input
            class="selectWidth"
            placeholder="请输入商户编号"
            v-model="search_sale.shopId"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-input
            class="selectWidth"
            placeholder="请输入商户名称"
            v-model="search_sale.shopName"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="授权状态">
          <el-select class="selectWidth" clearable v-model="search_sale.grantStatus" placeholder="请选择">
            <el-option :value="0" label="未授权"></el-option>
            <el-option :value="1" label="已授权"></el-option>
            <el-option :value="2" label="已过期"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户手机号">
          <el-input
            class="selectWidth"
            placeholder="请输入商户手机号"
            v-model="search_sale.shopPhone"
            auto-complete="off"></el-input>
        </el-form-item>
        <div>
          <auth-button
            opt="search"
            :plain="true"
            icon="el-icon-search"
            label="查询"
            @click.native="buttonSearch"
            :loading="checkLoading"></auth-button>
        </div>
      </el-form>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 列表模块 -->
      <el-table
        stripe
        style="border-radius:10px"
        align="center"
        v-loading="saleLoading"
        :data="sale_list">
        <el-table-column
          prop="shopId"
          label="商户编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="shopName"
          label="商户名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="shopPhone"
          label="商户手机号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="shopTypeName"
          label="店铺类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="leshuaMerchantId"
          label="乐刷编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="leshuaApproveStatusName"
          width="100"
          label="乐刷审核状态"
          align="center">
        </el-table-column>
        <el-table-column
          width="100"
          label="直属代理商(编号)"
          align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.agentName }}({{ scope.row.agentId }})</p>
          </template>
        </el-table-column>
        <el-table-column
          width="95"
          prop="grantTime"
          label="授权时间"
          align="center">
        </el-table-column>
        <el-table-column
          width="90"
          prop="expiredTime"
          label="过期时间"
          align="center">
        </el-table-column>
        <el-table-column
          width="100"
          prop="grantStatusName"
          label="授权状态"
          align="center">
          <template slot-scope="scope">
            <p style="color:#f95d5b" v-if="scope.row.grantStatus == 2">{{ scope.row.grantStatusName }}</p>
            <p v-else>{{ scope.row.grantStatusName }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="300"
          align="center"
          fixed="right"
          :context="_self">
          <template slot-scope="scope">
            <auth-button
              type="text"
              opt="search"
              @click.native="handleViewLog(scope.row)"
              label="查看日志"></auth-button>
            <auth-button
              v-if="+search_sale.isChainLogic === 0 && scope.row.showChainUpgradeBtn ===1"
              type="text"
              opt="edit"
              @click.native="handleShowAuthList(scope.row)"
              label="授权轻松版">
            </auth-button>
            <auth-button
              v-if="+search_sale.isChainLogic === 1 && scope.row.showChainUpgradeBtn ===1"
              type="text"
              opt="edit"
              @click.native="handleShowAuthList(scope.row, 1)"
              label="授权连锁版">
            </auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total > 10000 ? 10000 : paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>

    <!-- 非连锁 -->
    <el-dialog
      :title="authDialogTitle"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="isShowAuthListDiaog"
      width="30%">
      <div class="auth-list-wrap">
        <div class="item">
          <el-radio v-model="selectedServiceId" :label="item.id" v-for="(item, index) in authServiceList" :key="index">
            <p>{{item.activationServiceName}}<span v-if="item.remainCount >= 1 && +search_sale.isChainLogic === 0">(剩余{{item.remainCount}}个激活码)</span>
            </p>
          </el-radio>
        </div>
        <div v-if="+search_sale.isChainLogic === 1" class="shop-list">
          <p class="tip">
            当前需升级门店数量： <span class="warning">{{ upgradeCount }}</span>
          </p>
          <el-table
            border
            :data="shopList">
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="shopName"
              label="名称">
            </el-table-column>
            <el-table-column
              prop="shopId"
              label="门店编码">
            </el-table-column>
          </el-table>
        </div>
        <div class="footer">
          <el-button @click="doCloseAuthDialog">取消</el-button>
          <el-button type="primary" @click="goOrder">确认</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="操作日志"
      :visible.sync="isShowLogDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="45%">
      <div>
        <el-table
          :data="logList"
          style="width: 100%">
          <el-table-column
            prop="operateTime"
            label="操作日期"
            width="180">
          </el-table-column>
          <el-table-column
            prop="activationServiceName"
            label="授权套餐"
            width="180">
          </el-table-column>
          <el-table-column
            prop="expiredTime"
            label="授权后过期时间">
          </el-table-column>
          <el-table-column
            prop="grantStatusName"
            label="授权状态">
          </el-table-column>
          <el-table-column
            prop="grantor"
            label="授权人">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 非连锁 -->
    <el-dialog
      title="确认支付"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="isShowPayCodeDialog"
      width="30%">
      <div class="pay-code-wrap">
        <p class="title">{{selectedServiceName}}</p>
        <!-- <p class="name">应付金额</p>
        <p class="price">￥{{(preOrderInfo.totalPrice / 100).toFixed(2)}}</p> -->
        <p class="desc">请在<span class="mark">{{countTime}}分</span>钟内完成支付，超时自动关闭</p>
        <div class="wrap">
          <div class="header">
            <img class="icon" src="../../../assets/img/icon/wx.png" alt="">
            <p class="name">微信支付</p>
          </div>
          <div class="code">
            <!-- <img class="code-icon" src="../../../assets/img/icon/wx.png" alt=""> -->
            <div class="code-icon" id="jImgBox"></div>
            <p class="tips">打开微信，扫一扫即可付款</p>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 连锁 -->
    <el-dialog
      title="确认支付"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="isChainShowPayCodeDialog"
      width="30%">
      <div class="pay-code-wrap">
        <p class="title">连锁版管理系统-智掌柜码上餐厅-买断</p>
        <!-- <p class="name">应付金额</p>
        <p class="price">￥{{(preOrderInfo.totalPrice / 100).toFixed(2)}}</p> -->
        <p class="desc">请在<span class="mark">{{countTime}}分</span>钟内完成支付，超时自动关闭</p>
        <div class="wrap">
          <div class="header">
            <img class="icon" src="../../../assets/img/icon/wx.png" alt="">
            <p class="name">微信支付</p>
          </div>
          <div class="code">
            <!-- <img class="code-icon" src="../../../assets/img/icon/wx.png" alt=""> -->
            <div class="code-icon" id="jImgBox1"></div>
            <p class="tips">打开微信，扫一扫即可付款</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import {
  merchantAuthList, merchantAuthLogList, merchantAuthServiceList, merchantAuthPreOrder, merchantAuthActivation,
  upgradeShopList, upgradeToChainShop
} from '@/api/merchant.js'

export default {
  watch: {
    isShowPayCodeDialog (newValue) {
      if (newValue) {
        // 预下单
        this.merchantAuthPreOrder()
      } else {
        this.countTime = ''
        clearInterval(this.timer)
        clearInterval(this.intervalTime)
      }
    },
    isChainShowPayCodeDialog (newValue) {
      if (newValue) {
        // 预下单
        this.merchantAuthPreOrder()
      } else {
        this.countTime = ''
        clearInterval(this.timer)
        clearInterval(this.intervalTime)
      }
    }
  },
  data () {
    return {
      isShowChainAuthDialog: false,
      isChainShowPayCodeDialog: false,
      shopList: [],
      activeCodeCount: 0,
      upgradeCount: 0,
      radio: true,
      isShowLogDialog: false,
      isChain: 0,
      isShowAuthListDiaog: false,
      isShowPayCodeDialog: false,
      search_sale: {
        isChainLogic: '0', // 0-非连锁；1-连锁
        grantStatus: '',
        shopPhone: '',
        shopId: '',
        shopName: '',
        pageNo: '',
        pageSize: '',
        totalCount: ''
      },
      headShopId: '',
      saleLoading: false, // 列表加载
      checkLoading: false, // 查询加载
      sale_list: [], // 列表数据
      logList: [],
      authServiceList: [],
      selectedServiceId: '',
      selectedServiceName: '',
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },

      countTime: '', // 倒计时默认10分钟
      timer: null,
      intervalTime: null,
      selectedShopId: '',
      preOrderInfo: {
        orderId: '',
        createTime: '',
        count: '',
        totalPrice: '',
        unitPrice: ''
      }
    }
  },
  computed: {
    authDialogTitle () {
      return +this.search_sale.isChainLogic === 1 ? '授权连锁版' : ' 授权轻松版'
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 下单
    async merchantAuthPreOrder () {
      try {
        const activationCodeType = Number(this.search_sale.isChainLogic) === 0 ? 1 : 2// 写死。激活码类型：0-营销版激活码 1-门店版激活码。2-连锁激活码
        const res = await merchantAuthPreOrder({
          shopId: this.selectedShopId,
          activationServiceId: this.selectedServiceId,
          activationCodeType
        })
        this.preOrderInfo = res.data
        // activationCodeType: 激活码类型：0-营销版激活码 1-门店版激活码
        const qrCodeUrl = `https://zzgfs.leshuazf.com/zzg-mini-order/agent-authcode-pay.html?totalPrice=${this.preOrderInfo.totalPrice}&serviceName=${this.selectedServiceName}&orderId=${this.preOrderInfo.orderId}&shopId=${this.selectedShopId}&activationCodeType=${activationCodeType}&sessionId=${this.preOrderInfo.token}&activationServiceId=${this.preOrderInfo.activationServiceId}`
        document.getElementById('jImgBox').innerHTML = ''
        // eslint-disable-next-line
            new QRCode(document.getElementById('jImgBox'), {
          text: qrCodeUrl,
          width: 196, // 设置宽高
          height: 196
        })
        this.countTimeFn(600)
      } catch (e) {
        console.log(e)
      }
    },
    async handlerChainOrder (row) {
      this.isChainShowPayCodeDialog = true
      // try {
      //   const res = await upgradeOrderInit({
      //     shopId: row.shopId
      //   })
      //   if (res.error_code !== '0') return this.$message.error(res.error_msg)
      //   const qrCodeUrl = `https://zzgfs.leshuazf.com/zzg-mini-order/agent-authcode-pay.html?totalPrice=${res.data.payAmount}&serviceName=连锁版管理系统-智掌柜码上餐厅-买断&orderId=${res.data.orderId}&activationCodeType=1&sessionId=${this.preOrderInfo.token}&activationServiceId=${this.preOrderInfo.activationServiceId}`
      //   document.getElementById('jImgBox1').innerHTML = ''
      //   // eslint-disable-next-line
      //       new QRCode(document.getElementById('jImgBox1'), {
      //     text: qrCodeUrl,
      //     width: 196, // 设置宽高
      //     height: 196
      //   })
      // } catch (e) {
      //   console.log(e)
      // }
    },
    async upgradeShopList (item) {
      try {
        const res = await upgradeShopList({
          shopId: item.shopId
        })
        if (res.error_code !== '0') return this.$message.error(res.error_msg)
        // this.isShowChainAuthDialog = true
        this.shopList = res.data.shopList
        this.activeCodeCount = res.data.activeCodeCount
        this.upgradeCount = res.data.upgradeCount
      } catch (e) {
        console.log(e)
      }
    },
    handleTab (val) {
      this.search_sale.grantStatus = ''
      this.search_sale.shopPhone = ''
      this.search_sale.shopId = ''
      this.search_sale.shopName = ''
      // console.log(this.search_sale)
      this.getList()
    },
    countTimeFn (time) {
      // time 0 或者小于0 弹窗提示已过期，回到列表页面重新选择
      if (Number(time) === 0 || Number(time) < 0) {
        this.$message({
          type: 'warning',
          message: '二维码已经过期，请重新选择授权服务类型',
          duration: 3000
        })
        this.isShowPayCodeDialog = false
      }
      clearInterval(this.timer)
      var that = this
      var t = time
      var m = 0
      var s = 0
      m = Math.floor((t / 60) % 60)
      m < 10 && (m = '0' + m)
      s = Math.floor(t % 60)

      this.timer = setInterval(function countDown () {
        s--
        s < 10 && (s = '0' + s)
        if (s.length >= 3) {
          s = 59
          m = Number(m) - 1
        }
        if (m <= 0 && s <= 0) {
          m = '00'
          s = '00'
          // that.showPay = false
        }
        that.countTime = m + ':' + s
      }, 1000)
    },
    /**
       * @description 获取列表
       */
    getList () {
      this.saleLoading = true
      var params = this.formatSearch(this.search_sale)
      params.isChainLogic = Number(this.search_sale.isChainLogic)
      merchantAuthList(params).then((data) => {
        this.checkLoading = false
        if (data.error_code !== '0') {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.saleLoading = false
        } else {
          const { list, totalNum } = data.data
          this.saleLoading = false
          this.paginations.total = totalNum
          this.sale_list = list
        }
      }).catch(() => {
        this.checkLoading = false
        this.saleLoading = false
        this.$message({
          showClose: true,
          message: '请求超时，请重新登录',
          type: 'error'
        })
      })
    },
    onChangeCurrentPage (page) {
      this.search_sale.pageNo = page
      this.getList()
    },
    onSearch () {
      this.checkLoading = true
      this.getList()
    },
    buttonSearch () {
      // 当点击查询时，显示第一页
      this.search_sale.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    handleViewLog (row) {
      this.isShowLogDialog = true
      this.selectedShopId = row.shopId
      this.merchantAuthLogList()
    },
    handlerIsShowChainAuthDialog (row) {
      this.upgradeShopList(row)
    },
    // 非连锁
    handleShowAuthList (row) {
      this.selectedShopId = row.shopId
      if (+this.search_sale.isChainLogic === 0) {
        this.isShowAuthListDiaog = true
      } else {
        this.isShowAuthListDiaog = true
        this.upgradeShopList(row)
        this.headShopId = row.shopId
        // this.isShowChainAuthDialog = true
        // this.isChainShowPayCodeDialog = true
      }

      this.merchantAuthServiceList()
    },
    merchantAuthLogList () {
      const params = {
        isChainLogic: Number(this.search_sale.isChainLogic),
        shopId: this.selectedShopId,
        activationCodeType: Number(this.search_sale.isChainLogic) === 0 ? 1 : 2// 写死。激活码类型：0-营销版激活码 1-门店版激活码。2-连锁激活码
      }

      merchantAuthLogList(params).then((data) => {
        if (data.error_code !== '0') {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.logList = data.data.list
        }
      }).catch(() => {
        this.$message({
          showClose: true,
          message: '请求超时，请重新登录',
          type: 'error'
        })
      })
    },
    merchantAuthServiceList () {
      const params = {
        activationCodeType: Number(this.search_sale.isChainLogic) === 0 ? 1 : 2// 写死。激活码类型：0-营销版激活码 1-门店版激活码。2-连锁激活码
      }
      merchantAuthServiceList(params).then((data) => {
        if (data.error_code !== '0') {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.authServiceList = data.data.list
          if (+this.search_sale.isChainLogic === 1) {
            this.selectedServiceId = data.data.list && data.data.list[0].id
          }
        }
      }).catch(() => {
        this.$message({
          showClose: true,
          message: '请求超时，请重新登录',
          type: 'error'
        })
      })
    },
    doCloseAuthDialog () {
      this.isShowAuthListDiaog = false
      this.selectedServiceId = ''
    },
    merchantAuthActivation () {
      const params = {
        isChainLogic: Number(this.search_sale.isChainLogic),
        shopId: this.selectedShopId,
        activationServiceId: this.selectedServiceId,
        activationCodeType: Number(this.search_sale.isChainLogic) === 0 ? 1 : 2// 写死。激活码类型：0-营销版激活码 1-门店版激活码。2-连锁激活码
      }
      merchantAuthActivation(params).then((res) => {
        this.unbindLoading = false
        if (parseInt(res.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: res.error_msg,
            type: 'error'
          })
        } else {
          this.isShowAuthListDiaog = false
          this.$message.success('授权激活成功！')
        }
      })
    },
    async upgradeToChainShop () {
      try {
        const res = await upgradeToChainShop({
          headShopId: this.headShopId
        })
        if (+res.error_code !== 0) return this.$message.error(res.error_msg)
        this.isShowAuthListDiaog = false
        this.$message.success('授权激活成功！')
        this.getList()
      } catch (e) {
        console.log(e)
      }
    },
    goOrder () {
      // 授权连锁版购买
      if (+this.search_sale.isChainLogic === 1) {
        this.upgradeToChainShop()
        return
      }
      if (!this.selectedServiceId) {
        this.$message('请选择服务')
      } else {
        // 判断数量和是否是免费试用：数量大于1需要二次弹窗；免费试用的话不用去进行支付
        for (let i = 0; i < this.authServiceList.length; i++) {
          const item = this.authServiceList[i]
          if (item.id === this.selectedServiceId) {
            this.selectedServiceName = item.activationServiceName
            // 非连锁的
            if ((item.remainCount >= 1 && +this.search_sale.isChainLogic === 0)) {
              // 二次弹窗提示
              this.$confirm(`确定要授权${item.activationServiceName}吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.merchantAuthActivation()
              }).catch(() => {
              })
            } else {
              this.isShowAuthListDiaog = false
              this.isShowPayCodeDialog = true
            }
            break
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .list{
    padding-left: 16px;
  }
  .btm-action {
    margin: 20px 0;
    text-align: center;
  }
  .pagination {
    display: inline-block;
  }
  .btmBtn{
    margin-top: 10px;
  }
  .auth-list-wrap {
    .item {
      .el-radio {
        display: flex;
        align-items: center;
        line-height: 34px;
      }
      .active{
        color: #409EFF;
      }
    }
    .shop-list{
      padding: 20px 0;
      .tip{
        margin-bottom: 20px;
        .warning{
          color: red;
        }
      }
    }
    .footer {
      text-align: right;
    }
  }
  .pay-code-wrap {
    width: 360px;
    margin: 0 auto;
    .title {
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      color: #444444;
      padding-bottom: 40px;
    }
    .name {
      font-size: 16px;
      font-weight: 400;
      color: #7A7A7A;
      text-align: center;
    }
    .price {
      font-size: 36px;
      font-weight: 500;
      color: #ED3737;
      text-align: center;
      padding: 10px 0 20px 0;
    }
    .desc {
      font-size: 14px;
      font-weight: 400;
      color: #444444;
      text-align: center;
      .mark {
        color: #1B8DFF;
      }
    }
    .wrap {
      background: #FFFFFF;
      box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.1);
      border-radius: 20px;
      margin-top: 50px;
      .header {
        padding: 17px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .icon {
          width: 30px;
          height: 26px;
          margin-right: 12px;
        }
        .name {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
        }
      }
      .code {
        text-align: center;
        margin-top: 40px;
        .code-icon {
          width: 196px;
          height: 196px;
          margin: 0 auto;
        }
        .tips {
          padding-top: 20px;
          font-size: 16px;
          font-weight: 400;
          color: #252525;
          padding-bottom: 40px;
        }
      }
    }
  }
</style>
